import React, { useState } from 'react';
import { Copy, ChevronDown, ChevronUp } from 'lucide-react';

function TranscriptDisplay({ transcript, maxHeight = 300 }) {
  const [expanded, setExpanded] = useState(false);
  const [copied, setCopied] = useState(false);

  if (!transcript) return null;

  // Parse transcript entries
  const entries = transcript.entries || [];

  if (entries.length === 0) return null;

  // Handle copy to clipboard
  const handleCopy = () => {
    const text = entries.map(e => `${e.speaker}: ${e.text}`).join('\n');
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="border rounded-lg bg-gray-50">
      <div className="flex items-center justify-between px-3 py-2 border-b bg-white">
        <span className="text-xs font-medium text-gray-700">Call Transcript</span>
        <button
          onClick={handleCopy}
          className="text-xs text-gray-500 hover:text-gray-700 flex items-center"
          title="Copy to clipboard"
        >
          <Copy className="w-3.5 h-3.5" />
          {copied && <span className="ml-1 text-green-600">Copied!</span>}
        </button>
      </div>

      <div
        className="px-3 py-2 space-y-2 overflow-y-auto"
        style={{ maxHeight: expanded ? 'none' : `${maxHeight}px` }}
      >
        {entries.map((entry, idx) => (
          <div key={idx} className="text-xs">
            <span className="font-semibold text-gray-700">{entry.speaker}:</span>
            <span className="text-gray-900 ml-2">{entry.text}</span>
          </div>
        ))}
      </div>

      {entries.length > 5 && (
        <div className="border-t px-3 py-2 text-center">
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-xs text-gray-600 hover:text-gray-800 flex items-center justify-center mx-auto"
          >
            {expanded ? (
              <>
                Show Less <ChevronUp className="w-3 h-3 ml-1" />
              </>
            ) : (
              <>
                Show More <ChevronDown className="w-3 h-3 ml-1" />
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
}

export default TranscriptDisplay;
